export var DISCONNECT_OFFERS_ITV_ROUTE = 'index.customercare.customer.disconnectoffersitv';
export function routing($stateProvider) {
  $stateProvider.state(DISCONNECT_OFFERS_ITV_ROUTE, {
    url: '/removeOffers',
    template: '<disconnect-offers-itv class="u-flexKeepHeight"></disconnect-offers-itv>'
  });
}